import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class HisNumberValidators {
    public static isNumber( decimalPlaces?: number ): ValidatorFn {
        return ( control: AbstractControl<number | string> ): ValidationErrors => {
            if ( control?.value === null || control?.value === undefined ) {
                // leeres Input-Feld -> keine Validierung
                return null;
            }

            const numberValue = +control.value;
            if ( isNaN( numberValue ) || !Number.isFinite( numberValue ) ) {
                return { 'number': { 'number': true, 'input': control.value } };
            }

            return null;
        };
    }

    public static isInteger( options?: { min?: number; max?: number } ): ValidatorFn {
        return ( control: AbstractControl<number | string> ): ValidationErrors => {
            if ( control?.value === null || control?.value === undefined || control?.value === '' ) {
                // leeres Input-Feld -> keine Validierung
                return null;
            }

            const numberValue = +control.value;
            if ( isNaN( numberValue ) || !Number.isFinite( numberValue ) || !Number.isInteger( numberValue ) ) {
                return { 'integer': { 'integer': true, 'input': control.value } };
            }

            if ( options?.min !== undefined && numberValue < options.min ) {
                return { 'min': { 'min': options.min, 'actual': control.value } };
            }

            if ( options?.max !== undefined && numberValue > options.max ) {
                return { 'max': { 'max': options.max, 'actual': control.value } };
            }

            return null;
        };
    }
}
